import { API_URL } from '../../helpers/constants';
import request from '../../utils/request';
import {
  GetPriceCalendarByMonthPayload,
  GetPriceCalendarByRangePayload,
  PriceCalendar,
} from './types';

export const getPriceCalendarByMonth = async (
  payload: GetPriceCalendarByMonthPayload,
  signal?: AbortSignal,
): Promise<PriceCalendar> => {
  const parameters: URLSearchParams = new URLSearchParams(payload);

  const calendar: PriceCalendar = await request(
    `${API_URL}/priceCalendar/month?${parameters}`,
    { signal },
  );

  return calendar;
};

export const getPriceCalendarByRange = async (
  payload: GetPriceCalendarByRangePayload,
  signal?: AbortSignal,
): Promise<PriceCalendar> => {
  const parameters: URLSearchParams = new URLSearchParams(payload);

  const calendar: PriceCalendar = await request(
    `${API_URL}/priceCalendar/range?${parameters}`,
    { signal },
  );

  return calendar;
};
